import { useState } from 'react'

export const useAnimatedToggleOpen = (store, setOpen) => {
  const [animateClass, setAnimateClass] = useState(null)

  const toggleOpen = () => {
    const { isOpen } = store.widgetState
    if (window.innerWidth > 480) {
      return setOpen(!isOpen)
    }
    if (animateClass) {
      return
    }
    setAnimateClass(isOpen ? 'exiting' : 'entering')
    if (!isOpen) {
      setOpen(true)
    }

    setTimeout(() => {
      setAnimateClass('')
      if (isOpen) {
        setOpen(false)
      }
    }, 1000)
  }

  return { animateClass, toggleOpen }
}
